import {useFilterByLicense} from '@/biz/license.jsx'

export default () => {
    const filterByLicense = useFilterByLicense()

    return filterByLicense('M00010006', {
        title: '基线库',

        children: [
            {
                title: '当前基线',
                to: ['/PrjPatternBasList'],
            },

            {
                title: '目标基线',
                to: ['/PrjPatternTarList'],
            },

            {
                title: '代码验收',
                to: ['/AcceptCode'],
            },
        ],
    })
}
